module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHVsYXRpb25zISBZb3UgaGF2ZSBjb21wbGV0ZWQgdGhlIHR1dG9yaWFsLiAKSGF2ZSBhIGxvb2sgYXQgdGhlIFNvbGlkaXR5IGNvZGUgZm9yIHRoZSBjb250cmFjdCB5b3UganVzdCBpbnRlcmFjdGVkIHdpdGggYmVsb3cuCgpZb3UgYXJlIG5vdyByZWFkeSB0byBjb21wbGV0ZSBhbGwgdGhlIGxldmVscyBvZiB0aGUgZ2FtZSwgYW5kIGFzIG9mIG5vdywgeW91J3JlIG9uIHlvdXIgb3duLgoKR29kc3BlZWQhIQo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/instances_complete.md
// module id = 1386
// module chunks = 0